<template>
  <div class="print-table-wrapper">
    <h1 style="text-align: center; font-size: 40px;margin: 20px auto;">
      路桥集团会议议题提报单
    </h1>
    <table
      class="print-table"
      style="color: black;width: 600px;margin: 0 auto;"
    >
      <tbody>
        <tr>
          <th
            style="vertical-align: middle;width: 200px;box-sizing: border-box;white-space: nowrap;border-top: 1px solid black;border-left: 1px solid black;border-right: 1px solid black;padding: 10px;font-size: 20px;"
          >
            会议提报部门
          </th>
          <td
            style="text-align: center;vertical-align: middle;width: 100px;box-sizing: border-box;border-top: 1px solid black;border-right: 1px solid black;padding: 10px;"
          >
            {{ deptName }}
          </td>
          <th
            class="time-head"
            style="vertical-align: middle;width: 200px;width: 200px;box-sizing: border-box;box-sizing: border-box;white-space: nowrap;border-top: 1px solid black;border-right: 1px solid black;padding: 10px;font-size: 20px;"
          >
            会议时间
          </th>
          <td
            class="time-body"
            style="width: 100px;box-sizing: border-box;white-space: nowrap;border-top: 1px solid black;border-right: 1px solid black;padding: 10px;"
          ></td>
        </tr>
        <tr>
          <th
            style="vertical-align: middle;width: 200px;box-sizing: border-box;white-space: nowrap;border-top: 1px solid black;border-left: 1px solid black;border-right: 1px solid black;padding: 10px;font-size: 20px;"
          >
            会议类别
          </th>
          <td
            colspan="3"
            style="vertical-align: middle;border-top: 1px solid black;border-right: 1px solid black;padding: 10px;text-align: center;"
          >
            <div
              style="display: inline-block;margin-right: 10px;"
              v-for="(item, index) in meetingTypeList"
              :key="index"
            >
              <input
                type="checkbox"
                style="vertical-align: top;"
                :value="item.label"
                disabled
              />
              <span>{{ item.value }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <th
            style="vertical-align: middle;width: 200px;box-sizing: border-box;white-space: nowrap;border-top: 1px solid black;border-left: 1px solid black;border-right: 1px solid black;padding: 10px;font-size: 20px;"
          >
            会议议题
          </th>
          <td
            colspan="3"
            style="border-top: 1px solid black;border-right: 1px solid black;padding: 10px;"
          >
            {{ title }}
          </td>
        </tr>
        <tr>
          <th
            style="vertical-align: middle;width: 200px;box-sizing: border-box;white-space: nowrap;border-top: 1px solid black;border-left: 1px solid black;border-right: 1px solid black;padding: 10px;font-size: 20px;"
          >
            主要内容
            <br />
            （300字左右）
          </th>
          <td
            colspan="3"
            id="content"
            style="border-top: 1px solid black;border-right: 1px solid black;padding: 10px;"
          >
            <p style="line-height: 1.6;min-height: 300px;">
              {{ content }}
            </p>
          </td>
        </tr>
        <tr>
          <th
            style="vertical-align: middle;width: 200px;box-sizing: border-box;white-space: nowrap;border-top: 1px solid black;border-left: 1px solid black;border-right: 1px solid black;padding: 10px;font-size: 20px;"
          >
            参会人员
          </th>
          <td
            colspan="3"
            style="border-top: 1px solid black;border-right: 1px solid black;padding: 10px;line-height: 1.6;"
          >
            {{ joinStr }}
          </td>
        </tr>
        <tr>
          <th
            style="vertical-align: middle;width: 200px;box-sizing: border-box;white-space: nowrap;border-top: 1px solid black;border-left: 1px solid black;border-right: 1px solid black;padding: 10px;font-size: 20px;"
          >
            出席人
          </th>
          <td
            colspan="3"
            style="border-top: 1px solid black;border-right: 1px solid black;padding: 10px;line-height: 1.6;"
          >
            {{ checkStr }}
          </td>
        </tr>
        <tr>
          <th
            style="vertical-align: middle;width: 200px;box-sizing: border-box;white-space: nowrap;border-top: 1px solid black;border-left: 1px solid black;border-right: 1px solid black;padding: 10px;font-size: 20px;"
          >
            部门负责人意见
          </th>
          <td
            colspan="3"
            style="border-top: 1px solid black;border-right: 1px solid black;padding: 10px;"
          >
            <div v-if="master1">
              <p style="line-height: 1.6;margin: 10px auto;">{{ master1.opinion || "同意" }}</p>
              <div v-if="master1Sign" style="display: block;box-sizing: border-box;height: 50px;">
                <img style="display: block;width: auto;height: auto;max-height: 100%;object-fit: cover;" :src="master1Sign" alt="" />
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th
            style="vertical-align: middle;width: 200px;box-sizing: border-box;white-space: nowrap;border-top: 1px solid black;border-bottom: 1px solid black;border-left: 1px solid black;border-right: 1px solid black;padding: 10px;font-size: 20px;"
          >
            集团分管领导意见
          </th>
          <td
            colspan="3"
            style="border-top: 1px solid black;border-bottom: 1px solid black;border-right: 1px solid black;padding: 10px;"
          >
            <div v-if="master2">
              <p style="line-height: 1.6;margin: 10px auto;">{{ master2.opinion || "同意" }}</p>
              <div v-if="master2Sign" style="display: block;box-sizing: border-box;height: 50px;">
                <img style="display: block;width: auto;height: auto;max-height: 100%;object-fit: cover;"  :src="master2Sign" alt="" />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

/**
 * <BillTable
          :title="printTitle"
          :reportUserName="printReportUserName"
          :deptName="printDeptName"
          :content="printContent"
          :people="printPeople"
          :type="printTypeName"
          :join="printJoinWorkList"
          :check="printCheckWorkList"
        />
 */

import { getOtherConferenceTypeList } from "@/services/conferenceServices";
import Constants from "@/utils/consts";
import { getSign } from "@/services/basicDataService";
export default {
  name: "BillTable",
  props: {
    title: String,
    reportUserName: String,
    deptName: String,
    content: String,
    people: Array,
    type: String,
    join: Array, //参会人员
    check: Array, // 列席部门
  },
  data() {
    return {
      meetingTypeList: [],
      master1Sign: '',
      master2Sign: '',
      // master1Sign: "http://atom-contracts.oss-cn-shanghai.aliyuncs.com/user/sign/20201224/38135803580278475321980883.jpeg?Expires=1608863656&OSSAccessKeyId=LTAI4G23e2BQjPtntoCj9jpS&Signature=lGYeJH4OO6LwlzMV6mKr5YgOhqY%3D",
      // master2Sign: "http://atom-contracts.oss-cn-shanghai.aliyuncs.com/user/sign/20201224/38146228861465557578614599.jpeg?Expires=1608863683&OSSAccessKeyId=LTAI4G23e2BQjPtntoCj9jpS&Signature=OQlnNVfs7YJxPcWYD0mdIbOQxHY%3D",
    };
  },
  beforeUpdate() {
    this.master1Sign = '';
    this.master2Sign = '';
    console.log('beforeUpdatebeforeUpdatebeforeUpdatebeforeUpdate');
  },
  updated() {
    // console.log('updatedupdatedupdatedupdated');
    // this.people.forEach(item => {
    //   if (item.status != 99) {
    //     getSign({ signUserId: item.approveUserId}).then(res => {
    //       if (res.code == Constants.Code_OK) {
    //         this.$set(this, `master${item.sort}Sign`, res.data);
    //       } else {
    //         console.log('获取签名失败', item, res.msg);
    //       }
    //     }).catch(error => {
    //       console.log('获取签名失败', item, error);
    //     })
    //   }
    // })
  },
  mounted() {
    getOtherConferenceTypeList()
      .then((res) => {
        if (res.code == Constants.Code_OK) {
          let list = res.data || [];
          this.meetingTypeList = list.filter(item => item.label != "zthy");
        }
      })
      .catch((error) => {});
  },
  computed: {
    joinStr: function() {
      if (this.join) {
        let res = this.join.map((o) => {
          return o.displayName || o.name;
        });
        return res.join("、");
      }
      return "";
    },
    checkStr: function() {
      if (this.check) {
        let res = this.check.map((o) => {
          return o.displayName || o.name
        });
        return res.join("、");
      }
      return "";
    },
    peopleName: function() {
      if (this.people) {
        let res = [];
        this.people.forEach((o) => {
          if (o.status != 99) {
            // 99是创建提报单的人
            res.push(o.approveUserName);
          }
        });
        return res;
      }
      return [];
    },
    peopleOp: function() {
      let res = [];
      if (this.people) {
        this.people.forEach((o) => {
          if (o.status != 99) {
            // 99是创建提报单的人,不显示在上面
            res.push(o);
          }
        });
      }
      res.sort((a, b) => {
        // 依照sort值做一下排序
        return a.sort - b.sort;
      });
      return res;
    },
    master1: function() {
      let target = this.people.find(
        (item) => item.status != 99 && item.sort == 1
      );
      console.log("master1", target);
      return target;
    },
    master2: function() {
      let target = this.people.find(
        (item) => item.status != 99 && item.sort == 2
      );
      console.log("master2", target);
      return target;
    }
  },
};
</script>

<style lang="scss"></style>
